export default "__VITE_ASSET__f2eda3ef__"